/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/more_vertical_medium'
export default icon
